const news = {
	index:{
		more:'查看更多',
		banner: [{
			tips:'最新资讯',
			title:'',
			content:'',
			img: require('@/assets/img/index/GPI_2x.png'),
			url: require('@/assets/img/index/banner01.png')
		}],
	},
	detail:{
		banner: [{
			tips:'资讯详情',
			title:'',
			content:'',
			img: require('@/assets/img/index/GPI_2x.png'),
			url: require('@/assets/img/index/banner01.png')
		}],
		title:'资讯详情',
		Aditor:'编稿人:',
		Authors:'作者  |',
		Source:'来源  |',
		time:'发布时间：'
	}
}

export default news